import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import './Modal.css';

import Check from '../../svg/Check';

function NoSubscription({ cancelClick, trial = false }) {
  const openLink = () => {
    window.open(`https://www.${Config.API_NAME}.com/subscriptions?utm_medium=referral&utm_source=dj_web_app&utm_campaign=evergreen`, `_blank`);
  }
  return (
    <div className={`flexColumn onboard no-sub`}>
      <div className={`onboard-container`}>
        <div className={`flexColumn loginV2-container`}>
          <div className={`flexColumn loginV2-core modalV2 bottom-reduce`}>
            <div className={`flexColumn loginV2-body`}>
              <div className={`sub-title`}>{`A ${Config.API_NAME} streaming account is required to DJ.`}</div>
              <div className={`flexColumn description`}>
                <div className={`flexRow`} style={{gap: 8}}>
                  <Check style={{marginTop: -3}} />
                  <span>High-quality audio streaming</span>
                </div>
                <div className={`flexRow`} style={{gap: 8}}>
                  <Check style={{marginTop: -3}} />
                  <span>Personalized library with unlimited playlists</span>
                </div>
                <div className={`flexRow`} style={{gap: 8}}>
                  <Check style={{marginTop: -3}} />
                  <span>Mobile app and DJ web app</span>
                </div>
                <div className={`flexRow`} style={{gap: 8}}>
                  <Check style={{marginTop: -3}} />
                  <span style={{textAlign: `left`}}>Store tracks offline for DJing without internet</span>
                </div>
              </div>
              <div className={`cta`} onClick={openLink}>{trial ? `Try 30 days free` : `Subscribe Now`}</div>
              <a href={`https://stream.${Config.APP_NAME}.com/?utm_medium=referral&utm_source=dj_web_app&utm_campaign=evergreen`} target={`_blank`} rel="noopener noreferrer" className={`link grey`}>Learn More</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

NoSubscription.propTypes = {
  cancelClick: PropTypes.func,
  trial: PropTypes.bool
}

export default NoSubscription;
